/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CardInput from "../../components/payment/card";
import Color from "../../theme/color";
import { Button, Checkbox, Link } from "@mui/material";
import { usePersistentState } from "../../contexts/global-context";
import { STRING } from "../../resources/string";
import APIS from "../../config/api";
import { GET, POST } from "../../config/https";
import { useLocation } from "react-router-dom";
import WalletInput from "./wallet";
import { GetLocalStorage } from "../../utils/local-storage";
import { defaultState } from "../../utils/constant";

export default function PaymentForm({ handleCheckOut }: PaymentFormProps) {
  const location: any = useLocation();
  const [state, dispatch]: any = usePersistentState();
  const [activeSection] = useState(null);
  const [isAgree, setIsAgree] = useState(false);
  const [paymentOption, setPaymentOPtion] = useState({
    IsHost: false,
    IsStripe: false,
    IsZelle: false,
    hosttext: "",
  });
  const [defaultPaymentType, setDefaultPaymentType] = useState<any>();
  const totalTicketPrices = state?.CheckOutData?.totalTicketPrices;
  useEffect(() => {
    let newData = { ...state.CheckOutData, pyamentType: activeSection };

    dispatch({ CheckOutData: newData });
  }, [activeSection]);

  const checkOutData = GetLocalStorage("CheckOutData");
  const CouponInfo = GetLocalStorage("CouponInfo");
  const checkOutDataEventDetail = GetLocalStorage("CheckOutDataEventDetail");

  useEffect(() => {
    GetEventDetailFetch();
  }, []);

  const handleAccordionChange =
    (panel: string, id: number) =>
      (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
        handleCheckOutAmount(id);
        dispatch({ paymentTypeId: id });
        localStorage.setItem("paymentTypeId", JSON.stringify(id));

        setDefaultPaymentType(isExpanded ? panel : false);
      };

  useEffect(() => {
    dispatch({ CheckOutData: location?.state?.data });
  }, []);

  useEffect(() => {
    if (location?.state?.Event?.isZelle) {
      setDefaultPaymentType("zelle");
      handleCheckOutAmount(1002);
      dispatch({ paymentTypeId: 1002 });
      localStorage.setItem("paymentTypeId", JSON.stringify(1002));
    } else if (location?.state?.Event?.isStripe) {
      setDefaultPaymentType("stripe");
      handleCheckOutAmount(1);
      dispatch({ paymentTypeId: 1 });
      localStorage.setItem("paymentTypeId", JSON.stringify(1));
    } else if (location?.state?.Event?.isHost) {
      setDefaultPaymentType("eventHost");
      handleCheckOutAmount(2);
      dispatch({ paymentTypeId: 2 });
      localStorage.setItem("paymentTypeId", JSON.stringify(2));
    } else {
      setDefaultPaymentType("");
    }
  }, []);

  const handleCheckOutAmount = async (id: any) => {
    let checkTemp = checkOutData;
    dispatch({ showSkeleton: false });
    let ticketConfigs = checkTemp?.final?.map((x: any) => {
      return {
        id: x?.id,
        qty: x?.qty,
      };
    });
    let param = {
      couponCode: CouponInfo?.couponCode,
      email: CouponInfo?.email,
      eventId: state?.Event?.id,
      ticketConfigs: ticketConfigs,
      paymentType: id,
    };
    await POST(APIS.CHARGE_CALCULATION, param)
      .then((res: any) => {
        if (res?.isSuccess) {
          let temp = {
            ...checkOutData,
            totalTicketPrices: res?.result?.total,
            tax: res?.result?.tax,
            serviceFees: res?.result?.serviceFees,
            subTotal: res?.result?.subTotal,
            couponDiscountPrice: res?.result?.couponDiscountPrice,
            feeBreakdown: res?.result?.feeBreakdown,
          };
          dispatch({ CheckOutData: temp });
          dispatch({ showSkeleton: true });
          localStorage.setItem("CheckOutData", JSON.stringify(temp));
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const GetEventDetailFetch = async () => {
    // debugger;
    await GET(`${APIS.GET_BY_ID_EVENT}?id=${checkOutDataEventDetail?.eventId}`)
      .then((res: any) => {
        let newData = { ...paymentOption };
        newData.IsHost = res?.result?.isHost;
        newData.IsStripe = res?.result?.isStripe;
        newData.IsZelle = res?.result?.isZelle;
        newData.hosttext = res?.result?.hostText;
        setPaymentOPtion(newData);
        defaultState.paymentOption = newData;
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const label = { inputProps: { "aria-label": "Switch demo" } };
  const isStripeAvailable = location?.state?.Event?.isStripe && totalTicketPrices >= 0.1;
  const isZelleAvailable = location?.state?.Event?.isZelle && totalTicketPrices >= 0.1;
  const isFreeAvailable = !isStripeAvailable && !isZelleAvailable && totalTicketPrices === 0;
  // debugger;
  return (
    <div style={{ padding: "10px", marginTop: 30 }}>
      <Typography variant="h4" style={{ color: "GrayText" }} gutterBottom>
        Payment Options
      </Typography>
      {isFreeAvailable ? null : <WalletInput />}
      <Grid item xs={12} md={12} style={{ width: "100%", boxShadow: "0 1px 2px 0 rgba(0,0,0,.25)", marginTop: 20, }}>

        {
          location?.state?.Event?.isZelle && isZelleAvailable ? (
            <Accordion expanded={defaultPaymentType === "zelle"} onChange={handleAccordionChange("zelle", STRING.PAYMENT_TYPE_ID.ZELLE)}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" sx={{ backgroundColor: "#f2f2f2" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img src={require("../../assets/icons/icons8-zelle-48.png")} height={30} style={{ marginRight: 10 }} />
                  <Typography variant="h6">Zelle (least service fee; recommended)</Typography>
                </div>
              </AccordionSummary>

              <AccordionDetails>
                {/* <Card variant="outlined"> */}
                {/* <CardContent> */}
                <Typography>
                  <b> Step 1</b>:Initiate a Zelle transfer of{" "}
                  <b>$ {checkOutData?.totalTicketPrices}</b> to
                  <Link href="mailto:pay@eventprix.com" color={Color.primary}>{" "}pay@eventprix.com</Link>.
                </Typography>
                <br />
                <Typography><b> Step 2:</b> Under "Add message" on Zelle screen, provide the Order id of your ticket purchase. Your <b> "Order id"</b> will be provided after you click on <b>Place Order.</b></Typography>
                <br />
                <Typography>You will receive your tickets by email at the address you entered within 24 hours. If you have questions, reach out to your event organizer or send us an email at{" "}
                  <Link href="mailto:contact@eventprix.com" color={Color.primary}>{" "}contact@eventprix.com</Link>.
                </Typography>

                <br />
                <div style={{ width: "100%", display: "flex", alignItems: "center", marginTop: "7px" }}>
                  <Checkbox style={{ height: "10px", width: "10px", marginRight: "8px" }} {...label} onChange={() => setIsAgree(!isAgree)} value={isAgree} />
                  <Typography sx={{ width: "80%", fontWeight: "600" }}>
                    I agree to the
                    <Link href="/terms-and-conditions" target="_blank" rel="noopener noreferrer" color={Color.primary}>
                      {" "}terms{" "}
                    </Link>
                    {" "}and acknowledge the
                    <Link href="/privacy-and-policy" color={Color.primary} target="_blank" rel="noopener noreferrer">{" "}privacy policy.</Link>
                  </Typography>
                </div>
                <Button size="medium" variant="contained" sx={{ boxShadow: "none" }} style={{ backgroundColor: Color.primary, marginTop: "10px" }}
                  fullWidth onClick={() => handleCheckOut("zelle", STRING.PAYMENT_TYPE_ID.ZELLE, isAgree)}>
                  Submit Payment
                </Button>
              </AccordionDetails>
            </Accordion>
          ) : null
        }

        {
          isStripeAvailable ? (
            <Accordion expanded={defaultPaymentType === "stripe"} onChange={handleAccordionChange("stripe", STRING.PAYMENT_TYPE_ID.CARD)}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header" sx={{ backgroundColor: "#f2f2f2" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img src={require("../../assets/icons/credit.png")} style={{ marginRight: 10 }} height={30} />
                  <Typography variant="h6">Pay with credit / debit card</Typography>
                </div>
              </AccordionSummary>

              <AccordionDetails>
                <div style={{ marginTop: "8px" }}>
                  <CardInput />
                </div>
              </AccordionDetails>
            </Accordion>
          ) : null
        }

        {
          !isFreeAvailable && location?.state?.Event?.isHost ? (
            <Accordion expanded={defaultPaymentType === "eventHost"} onChange={handleAccordionChange("eventHost", STRING.PAYMENT_TYPE_ID.PAY_TO_HOST)}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel3a-content" id="panel3a-header" sx={{ backgroundColor: "#f2f2f2" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img src={require("../../assets/icons/cash-on-delivery.png")} style={{ marginRight: 8 }} height={30} width={35} />
                  {defaultPaymentType === "eventHost"}
                  <Typography variant="h6">
                    Pay to event host {" "}
                    {defaultPaymentType === "eventHost" ? `- Total Amount:$${checkOutData?.totalTicketPrices}` : ""}
                  </Typography>
                </div>
              </AccordionSummary>

              <AccordionDetails>

                {/* Please pay the total amount shown above to your host and click
                on ‘Place Order’. Remember to share your ‘Order Id’, which will
                be displayed on the next page, with your host. You will receive
                your tickets by email at the address you entered within 24
                hours. Please note that EventPrix cannot be held liable for any
                issues related to this transaction. */}
                {/* {paymentOption.hosttext} */}
                {/* <p style={{ whiteSpace: "pre-line" }}>
                {paymentOption.hosttext}
              </p> */}
                <p style={{ whiteSpace: "pre-line" }}>
                  {paymentOption?.hosttext?.split(/(\S+@\S+\.\S+)/g).map((part, index) => {
                    if (/^\S+@\S+\.\S+$/.test(part)) {
                      return (<a key={index} href={`mailto:${part}`} style={{ color: "#1976d2", fontWeight: "bold", textDecoration: "underline" }}>{part}</a>);
                    }
                    return part;
                  })}
                </p>
                {/* <Typography>
                <b> Step 1</b>:Initiate a Zelle transfer of{" "}
                <b>$ {checkOutData?.totalTicketPrices}</b> to
                <Link href="mailto:muqabaladancers@gmail.com" color={Color.primary}>
                  {" "}
                  muqabaladancers@gmail.com
                </Link>
                .
              </Typography>
              <br />
              <Typography>
                <b> Step 2:</b> Under "Add message" on Zelle screen, provide the
                Order id that is shown above. 
              </Typography>
              <br />
              <Typography>
                We will email your tickets to in less than 24 hours. If you have questions, 
                reach out to your event organizer
                 or send us an email at{" "}
                <Link href="mailto:muqabaladancers@gmail.com" color={Color.primary}>
                  {" "}
                  muqabaladancers@gmail.com
                </Link>
                .
              </Typography> */}

                <br /><br />
                <div style={{ width: "100%", display: "flex", alignItems: "center", marginTop: "7px" }}>
                  <Checkbox style={{ height: "10px", width: "10px", marginRight: "8px" }}{...label} onChange={() => setIsAgree(!isAgree)} value={isAgree} />
                  <Typography sx={{ width: "80%", fontWeight: "600" }}>
                    I agree to the
                    <Link href="/terms-and-conditions" target="_blank" rel="noopener noreferrer" color={Color.primary}>
                      {" "}
                      terms{" "}
                    </Link>{" "}
                    and acknowledge the
                    <Link href="/privacy-and-policy" target="_blank" rel="noopener noreferrer" color={Color.primary}>
                      {" "}privacy policy.
                    </Link>
                  </Typography>
                </div>
                <Button size="medium" variant="contained" sx={{ boxShadow: "none" }} style={{ backgroundColor: Color.primary, marginTop: "10px" }}
                  fullWidth onClick={() => handleCheckOut("Pay_to_event_host", STRING.PAYMENT_TYPE_ID.PAY_TO_HOST, isAgree)}>
                  Submit Payment
                </Button>
              </AccordionDetails>
            </Accordion>
          ) : null}

        {
          isFreeAvailable ? (
            <Accordion expanded={defaultPaymentType === "freeTicket"} onChange={handleAccordionChange("freeTicket", STRING.PAYMENT_TYPE_ID.ISSUE_FREE_TICKET)}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel3a-content" id="panel3a-header" sx={{ backgroundColor: "#f2f2f2" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img src={require("../../assets/icons/free.png")} style={{ marginRight: 8 }} height={30} width={35} />
                  {defaultPaymentType === "freeTicket"}
                  <Typography variant="h6">
                    Free Tickets                    
                  </Typography>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                {/* <p style={{ whiteSpace: "pre-line" }}>
                  {paymentOption?.hosttext?.split(/(\S+@\S+\.\S+)/g).map((part, index) => {
                    if (/^\S+@\S+\.\S+$/.test(part)) {
                      return (<a key={index} href={`mailto:${part}`} style={{ color: "#1976d2", fontWeight: "bold", textDecoration: "underline" }}>{part}</a>);
                    }
                    return part;
                  })}
                </p>                 */}
                {/* <br /><br /> <div style={{ width: "100%", display: "flex", alignItems: "center", marginTop: "7px" }}>
                  <Checkbox style={{ height: "10px", width: "10px", marginRight: "8px" }}{...label} onChange={() => setIsAgree(!isAgree)} value={isAgree} />
                  <Typography sx={{ width: "80%", fontWeight: "600" }}>
                    I agree to the
                    <Link href="/terms-and-conditions" target="_blank" rel="noopener noreferrer" color={Color.primary}>
                      {" "}
                      terms{" "}
                    </Link>{" "}
                    and acknowledge the
                    <Link href="/privacy-and-policy" target="_blank" rel="noopener noreferrer" color={Color.primary}>
                      {" "}privacy policy.
                    </Link>
                  </Typography>
                </div> */}
                <Button size="medium" variant="contained" sx={{ boxShadow: "none" }} style={{ backgroundColor: Color.primary, marginTop: "10px" }}
                  fullWidth onClick={() => handleCheckOut("Pay_to_event_host", STRING.PAYMENT_TYPE_ID.ISSUE_FREE_TICKET, true)}>
                  Submit Details
                </Button>
              </AccordionDetails>
            </Accordion>
          ) : null}
      </Grid>
    </div>
  );
}

interface PaymentFormProps {
  handleCheckOut: (key: string, id: number, isAgree: boolean) => void;
}
